import React, { Component } from 'react';
import get from 'lodash/get';
import SlidePanel from 'yoda-account-components/lib/components/SlidePanel/SlidePanel';
import Input from 'yoda-core-components/lib/components/Input/Input';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import RadioButton from 'yoda-core-components/lib/components/RadioButton/radio';
import Button from 'yoda-core-components/lib/components/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import PropTypes from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { normalizeDate } from '../../common/DateMask/DateMask';
import {
    genericErrorMessage,
    listNameRegExp,
    listEmptyListNameMessage,
} from '../../common/Constants';

class ListSettings extends Component {
    static defaultProps = {
        eventDate: '',
        isPublic: false,
        hideBackArrowCloseButton: false,
        showSlider: false,
        saveToList: {},
        deleteListClicked: {},
        isMyFavorites: false,
        actions: {},
    };

    static propTypes = {
        listName: PropTypes.string.isRequired,
        eventDate: PropTypes.instanceOf(Date),
        isPublic: PropTypes.bool,
        hideBackArrowCloseButton: PropTypes.bool,
        saveToClicked: PropTypes.func.isRequired,
        closeModal: PropTypes.func.isRequired,
        listId: PropTypes.string.isRequired,
        messagesTexts: PropTypes.objectOf.isRequired,
        showSlider: PropTypes.bool,
        /* eslint react/no-unused-prop-types: 0 */
        saveToList: PropTypes.object,
        deleteListClicked: PropTypes.object,
        isMyFavorites: PropTypes.bool,
        actions: PropTypes.object,
    };

    static getDerivedStateFromProps(nextProps) {
        const errorCode = get(nextProps, 'saveToList.error.errorCode');
        const errorMessage = get(nextProps, 'saveToList.error.errorMessage');
        const requestFrom = get(nextProps, 'saveToList.requestFrom');
        const { messagesTexts } = nextProps;
        if (requestFrom && nextProps.saveToList.isSuccess && !nextProps.saveToList.isLoading) {
            if (requestFrom === 'UPDATE') {
                return {
                    error: get(
                        messagesTexts.myListing,
                        'updateSettingSuccessMsg',
                        'Your settings have been saved.'
                    ),
                    type: 'success',
                    formChanged: false,
                };
            }

            if (requestFrom === 'DELETE') {
                return {
                    closeSlider: true,
                };
            }
        } else if (errorCode) {
            return {
                error: errorMessage || get(genericErrorMessage, 'genericError'),
                type: 'error',
            };
        }
        return {
            error: '',
            type: '',
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            formChanged: false,
            currentPrivacySetting: props.isPublic,
            eventDate: props.eventDate,
            hideBackArrowCloseButton: props.hideBackArrowCloseButton,
            error: '',
            panelTitleAlignment: 'default',
            showDeleteModel: false,
            setMyListNameLocal: props.listName,
            showDateError: false,
            dateLabelDisplay: !!(props.listId !== 'myFavorites' && props.eventDate !== ''),
        };
        this.onPrivacySettingsChange = this.onPrivacySettingsChange.bind(this);
        this.handleEventDateChange = this.handleEventDateChange.bind(this);
    }

    componentDidUpdate() {
        if (this.state.closeSlider) {
            this.props.closeModal();
            window.location.assign('/mylist');
        }
    }

    handleEventDateChange(date) {
        const eventDate = date;
        this.setState({
            eventDate,
        });
    }

    onPrivacySettingsChange(e) {
        this.onCloseError();
        this.setState({ formChanged: true });
        this.setState({ currentPrivacySetting: e.target.value === 'Public' });
    }

    onDateFocus = () => {
        this.setState({ dateLabelDisplay: true });
    };

    formatDate = (value) => {
        this.onCloseError();
        this.setState({ formChanged: false });
        this.setState({ showDateError: true });
        this.setState({ dateLabelDisplay: true });
        const dateReg = /(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/;
        if (value === '') {
            this.setState({ showDateError: false });
            this.setState({ formChanged: true });
        } else if (dateReg.test(value)) {
            const todayDate = new Date().getTime();
            const ipDate = value.split('/');
            const selectedDate = new Date(value).getTime();
            if (todayDate - selectedDate < 0) {
                this.setState({ showDateError: false });
                this.setState({ formChanged: true });
            }
            // const oldNoMonth = ['01', '03', '05', '07', '08', '10', '12'];
            const evenNoMonth = ['04', '06', '09', '11'];

            // Leap Year validation allowed only upto 29 days
            if (ipDate[0] === '02' && parseInt(ipDate[2]) % 4 === 0 && parseInt(ipDate[1]) > 29) {
                this.setState({ showDateError: true });
                this.setState({ formChanged: false });
                // Non-Leap Year validation allowed only upto 28 days
            } else if (
                ipDate[0] === '02' &&
                parseInt(ipDate[2]) % 4 !== 0 &&
                parseInt(ipDate[1]) > 28
            ) {
                this.setState({ showDateError: true });
                this.setState({ formChanged: false });
            } else if (evenNoMonth.includes(ipDate[0]) && parseInt(ipDate[1]) > 30) {
                this.setState({ showDateError: true });
                this.setState({ formChanged: false });
            }
        }
        this.handleEventDateChange(value);
    };

    clearErrorMsg = (value) => {
        if (value === '') {
            this.setState({ showDateError: false });
            this.setState({ formChanged: true });
            this.setState({ dateLabelDisplay: false });
        }
    };

    resetState = () => {
        this.setState({
            formChanged: false,
            showDeleteModel: false,
        });
    };

    deleteListClicked = () => {
        this.setState({ showDeleteModel: true });
    };

    confirmDeleteList = () => {
        this.props.deleteListClicked(this.props.listId);
        this.resetState();
    };

    cancelDeleteList = () => {
        this.resetState();
    };

    saveList = () => {
        let errorMessage = '';
        const { messagesTexts, actions } = this.props;
        const listName = get(this.listName, 'value', '').trim();
        if (!listName) {
            errorMessage = listEmptyListNameMessage;
        } else if (!listNameRegExp.test(listName)) {
            errorMessage = get(messagesTexts.myListing, 'listSettings.invalidListNameMessage');
        }
        if (!errorMessage) {
            // this.setState({ listId: this.props.listId });
            this.props.saveToClicked(
                listName,
                this.state.currentPrivacySetting,
                this.state.eventDate,
                this.props.listId
            );
        } else {
            actions.setListError({
                errorMessage,
                errorCode: 'error',
            });
        }
    };

    closeModal = () => {
        this.props.closeModal();
        this.resetState();
    };

    successCloseModal = () => {
        this.props.closeModal(true);
        this.resetState();
    };

    listNameOnChange = (value = '') => {
        const { messagesTexts, actions } = this.props;
        const listName = value.trim();

        if (!listNameRegExp.test(listName)) {
            if (listName.length > 24) {
                actions.setListError({
                    errorMessage: get(
                        messagesTexts.myListing,
                        'listSettings.invalidListNameMessage'
                    ),
                    errorCode: 'error',
                });
                return;
            }
        } else {
            actions.clearListError();
            actions.resetList();
        }
        this.setState({ setMyListNameLocal: value });
        this.setState({ formChanged: true });
    };

    onCloseError = () => {
        this.props.actions.clearListError();
        this.props.actions.resetList();
    };

    listBlock = () => {
        const { isMyFavorites, messagesTexts } = this.props;
        const {
            type,
            error,
            currentPrivacySetting,
            eventDate,
            formChanged,
            showDateError,
        } = this.state;
        const buttonClass = formChanged
            ? dt(['w-full'])
            : dt(['w-full', 'cursor-not-allowed', 'text-gray-300']);
        const readOnlyClass = isMyFavorites
            ? dt([
                  'block',
                  'w-full',
                  'h-12',
                  'text-medium',
                  'py-3',
                  'px-5',
                  'border',
                  'border-dashed',
                  'border-gray-25',
                  'rounded-lg',
                  'bg-light-white',
                  'text-gray-40',
              ])
            : dt([
                  'block',
                  'w-full',
                  'h-12',
                  'text-medium',
                  'py-3',
                  'px-5',
                  'border',
                  'border-solid',
                  'border-gray-60',
                  'rounded-lg',
                  'text-black',
              ]);
        const errorInputbox = dt([
            'block',
            'w-full',
            'h-12',
            'text-medium',
            'py-3',
            'px-5',
            'rounded-lg',
            '!text-black',
            'border-2',
            'border-solid',
            'border-error-border',
        ]);
        const placeholderClass =
            eventDate !== ''
                ? dt(['!text-black'])
                : dt(['placeholder:italic', !isMyFavorites && '!text-gray-60']);
        const errorDateMessage =
            get(messagesTexts.myListing, 'listSettings.invalidDateMessage') || '';
        return (
            <div>
                {error && (
                    <MessageBox
                        type={type}
                        title={error}
                        level="section"
                        automationId="list-settings-error"
                        onClose={this.onCloseError}
                        theme={dt(['smMd:mt-6', 'lg:mt-8', '!mb-[9px]'])}
                    />
                )}
                <div className={dt(['mb-6', 'relative', 'pt-[15px]'])}>
                    <label
                        htmlFor="listName"
                        className={dt([
                            'absolute',
                            'top-0',
                            'left-3',
                            'text-xsmall',
                            'z-[99]',
                            'bg-white',
                            'p-[5px]',
                            'text-gray-70',
                        ])}
                    >
                        List Name
                    </label>
                    <Input
                        data-automation-id="list-settings-input"
                        type="text"
                        name="listName"
                        onChange={this.listNameOnChange}
                        value={this.state.setMyListNameLocal}
                        readOnly={isMyFavorites}
                        refCallBack={(component) => {
                            this.listName = component;
                        }}
                        theme={readOnlyClass}
                    />
                    {isMyFavorites && (
                        <span
                            className={dt([
                                'text-small',
                                'font-open-sans-regular',
                                'text-gray-60',
                                'block',
                            ])}
                        >
                            Only custom lists can be renamed
                        </span>
                    )}
                </div>
                <div className={dt(['mb-6', 'text-base', 'text-black'])}>
                    <div className={dt(['mb-4', 'grid'])}>
                        <RadioButton
                            name="Private"
                            type="radio"
                            id="private"
                            value="Private"
                            label="Private"
                            // labelclassName={dt(['text-black', 'text-base', 'pl-2'])}
                            checked={!currentPrivacySetting}
                            onChange={this.onPrivacySettingsChange}
                            automationId="list-settings-private-radio"
                        />
                        <span className={dt(['text-small', 'ml-9', 'text-gray-60'])}>
                            Only I can see my list
                        </span>
                    </div>
                    <div className={dt(['grid'])}>
                        <RadioButton
                            name="public"
                            type="radio"
                            id="public"
                            value="Public"
                            label="Public"
                            // labelclassName={dt(['text-black', 'text-base', 'pl-2'])}
                            checked={currentPrivacySetting}
                            onChange={this.onPrivacySettingsChange}
                            automationId="list-settings-public-radio"
                        />
                        <span className={dt(['text-small', 'ml-9', 'text-gray-60'])}>
                            Anyone with a link can access my list
                        </span>
                    </div>
                </div>
                <div
                    className={dt([
                        'mb-6',
                        'relative',
                        this.props.listName === 'My Favorites' && 'pointer-events-none',
                    ])}
                >
                    {this.state.dateLabelDisplay && (
                        <label
                            htmlFor="eventdate"
                            className={dt([
                                'absolute',
                                'top-[-15px]',
                                'left-3',
                                'text-xsmall',
                                'z-[99]',
                                'bg-white',
                                'p-[5px]',
                                showDateError ? 'text-error-border' : 'text-gray-70',
                            ])}
                        >
                            Event Date (Optional)
                        </label>
                    )}
                    <Input
                        id="eventdate"
                        name="eventdate"
                        type="text"
                        readOnly={isMyFavorites}
                        theme={showDateError ? errorInputbox : readOnlyClass}
                        placeholder={!this.state.dateLabelDisplay ? 'Event Date (Optional)' : ''}
                        value={normalizeDate()(eventDate)}
                        onChange={this.formatDate}
                        automationId="list-settings-event-date"
                        inputClassName={placeholderClass}
                        onBlur={this.clearErrorMsg}
                        onFocus={this.onDateFocus}
                    />
                    {isMyFavorites ? (
                        <span className={dt(['text-small', 'text-gray-60', 'block'])}>
                            Event Date is only available for custom lists
                        </span>
                    ) : (
                        <span
                            className={dt([
                                'text-small',
                                showDateError ? 'text-error-border' : 'text-gray-60',
                                'block',
                            ])}
                        >
                            {showDateError ? errorDateMessage : 'mm/dd/yyyy'}
                        </span>
                    )}
                </div>
                <Button
                    automationId="save-list"
                    isDisabled={!formChanged}
                    className={buttonClass}
                    onClick={this.saveList}
                >
                    Save
                </Button>
                {!isMyFavorites && (
                    <div className={dt(['flex', 'justify-center'])}>
                        <div>
                            <p
                                className={dt([
                                    'text-right',
                                    'leading-none',
                                    'font-open-sans-regular',
                                ])}
                            >
                                <Button
                                    automationId="delete-this-list"
                                    buttonType="Text"
                                    type="button"
                                    size="Md"
                                    className={dt(['mt-4', 'w-full', 'text-center'])}
                                    onClick={this.deleteListClicked}
                                >
                                    Delete This List
                                </Button>
                            </p>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    deleteModelBox = () => {
        const { showDeleteModel } = this.state;
        const { messagesTexts } = this.props;
        const { content, deleteButton, cancelButton, title } =
            messagesTexts.myListing.deleteModel || {};

        return showDeleteModel ? (
            <ModalBox
                onClose={this.cancelDeleteList}
                showModal={showDeleteModel}
                modalOverlayTheme={dt(['!z-[102]'])}
                modalHeaderTheme={dt(['items-center'])}
                modalTitleTheme={dt(['text-left', 'sm:text-xlarge', 'lg:text-2xlarge'])}
                modalContentTheme={dt(['mt-6'])}
                defaultHeader
                title={title}
            >
                <div className={dt(['mb-6', 'text-medium'])}>{content}</div>

                <div className={dt(['lg:flex', 'lg:flex-row-reverse'])}>
                    <Button
                        automationId="delete-list"
                        size="Md"
                        className={dt(['smMd:w-full', 'lg:w-[300px]', 'lg:ml-9'])}
                        onClick={this.confirmDeleteList}
                    >
                        {deleteButton}
                    </Button>
                    <Button
                        buttonType="Text"
                        size="Md"
                        automationId="cancel-list"
                        className={dt([
                            'w-auto',
                            'smMd:mt-4',
                            'smMd:mx-auto',
                            'smMd:!min-h-[auto]',
                        ])}
                        onClick={this.cancelDeleteList}
                    >
                        {cancelButton}
                    </Button>
                </div>
            </ModalBox>
        ) : null;
    };

    formRender() {
        return (
            <div className={dt(['mx-6', 'mt-[9px]'])} data-automation-id="modalForm">
                {/* List Settings update Block */}
                {this.listBlock()}
                {/* Success Message Block */}
            </div>
        );
    }

    render() {
        return (
            <div>
                <SlidePanel
                    isOpenPanel={this.props.showSlider}
                    panelTitleClassName={dt([
                        'font-open-sans-regular',
                        'text-medium',
                        'smMd:text-large',
                        'smMd:leading-7',
                        '-tracking-[0.24px]',
                    ])}
                    panelTitle={!this.state.hideBackArrowCloseButton && 'List Settings'}
                    panelIcon=""
                    panelTitleAlignment={this.state.panelTitleAlignment}
                    hideBackArrowCloseButton={this.state.hideBackArrowCloseButton}
                    onPrimaryCloseButtonClick={this.closeModal}
                    isPrimaryCloseButtonRequired
                    showBackIcon={false}
                >
                    {this.formRender()}
                </SlidePanel>
                {this.deleteModelBox()}
            </div>
        );
    }
}

export default ListSettings;
